import { Component } from '@angular/core';

@Component({
  selector: 'fnsr-template-create',
  standalone: true,
  imports: [],
  templateUrl: './template-create.component.html',
  styles: ``
})
export class TemplateCreateComponent {

}
